import { useState } from 'react';
import { css } from '@emotion/react';
import { Grid } from '@material-ui/core';
import { colors } from '@/styles';
import { useClientUser } from '@/hooks';
import { OnwardCardTab, OnwardCardTabContainer } from '@/components/Tabs';
import SKUs from '../SKUs';
import ServiceCatalog from '../ServiceCatalog';

const TABS = [
    { label: "SKU's", value: 0 },
    { label: 'Services', value: 1 },
];

// `readOnly` shows another client's SKUs and services (a carrier looking at a partner shipper)
// with no way to change them.
const SKUsAndServices = ({ clientRef, readOnly = false }) => {
    const { accountType } = useClientUser();
    // Service catalogs are shipper-owned: the Services sub-tab shows on shipper accounts, and on
    // the read-only view of a shipper.
    const showServices = readOnly || accountType === 'shipper';
    const tabs = showServices ? TABS : TABS.filter((t) => t.value === 0);
    const [tab, setTab] = useState(0);
    const activeTab = showServices ? tab : 0;

    return (
        <div>
            <OnwardCardTabContainer
                textColor="primary"
                indicatorColor="primary"
                value={activeTab}
                onChange={(_, next) => setTab(next)}
            >
                {tabs.map((t) => (
                    <OnwardCardTab key={`sku-services-tab-${t.value}`} {...t} />
                ))}
            </OnwardCardTabContainer>
            <Grid
                container
                css={css`
                    background-color: white;
                    border: 1px solid ${colors.greys.border};
                    width: 100%;
                    padding: 1rem 2rem;
                    border-top-left-radius: 0;
                `}
            >
                {activeTab === 0 && <SKUs clientRef={clientRef} readOnly={readOnly} />}
                {activeTab === 1 && <ServiceCatalog clientRef={clientRef} readOnly={readOnly} />}
            </Grid>
        </div>
    );
};

export default SKUsAndServices;
